<template>
    <div class="modal fade show modal-style" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog-centered" ref="modalRef">
            <div class="modal-content w-70 mx-auto">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">{{ rewardId ? 'Update' : 'Add' }} Reward Points</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="row py-1 mx-auto">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-6">
                            <label for="colFormLabel" class="col-form-label">Customer </label>
                            <AsyncSelect
                                placeholder="Party Name, ID, Mobile No"
                                :api-service="fetchContactProfiles"
                                :reduce="(name) => name.id"
                                v-model="formData.contact_profile_id"
                                :additional-query="{type: 'customer'}"
                                :format-label="formatPatientLabel"
                                :additional-option="rewardData ? [{
                                    id: rewardData.contact_profile_id,
                                    name: rewardData.name
                                }] : []"
                                :disabled="!! rewardId"
                            />
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                            <label for="colFormLabel" class="col-form-label">Mobile No </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                :value="customerMobile"
                                tabindex="1"
                                placeholder="Mobile"
                                type="number"
                                readonly
                            >
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                          <label for="colFormLabel" class="col-form-label">Date </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                v-model="formData.date"
                                tabindex="1"
                                type="date"
                                placeholder=""
                            >
                        </div>
                    </div>

                    <div class="row py-1 mx-auto">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-6">
                            <label for="colFormLabel" class="col-form-label">Reward Point Expense Account (P&L)</label>
                            <AsyncSelect
                                placeholder="Select Account Head"
                                :api-service="fetchAccountHeadsList"
                                :reduce="(name) => name.id"
                                v-model="formData.account_head_id"
                                :additional-query="{cash_bank_hide: 'yes',
                                                    status: 'active'}"
                                :format-label="formatPatientLabel"
                                :additional-option="rewardData ? [{
                                    id: rewardData.account_head_id,
                                    name: rewardData.account_head_name
                                }] : []"
                            />
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 col-lg-6">
                            <label for="colFormLabel" class="col-form-label">Reward Point Liability Account</label>
                            <v-select
                                placeholder="Select Liability Head"
                                :options="rewardPointAcc"
                                :reduce="(name) => name.id"
                                v-model="formData.liability_head_id"
                                label="name"
                            />
                        </div>
                    </div>

                    <div class="row py-1 mx-auto">
                        <div v-if="! rewardId" class="col-12 col-sm-6 col-md-4 col-lg-4">
                            <label for="colFormLabel" class="col-form-label">Current Balance </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                :value="rewardBalance"
                                tabindex="1"
                                placeholder="Current Balance"
                                type="number"
                                readonly
                            >
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                            <label for="colFormLabel" class="col-form-label">New Points </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                v-model="formData.points"
                                tabindex="1"
                                placeholder="New Points"
                                type="number"
                            >
                        </div>

                        <div v-if="! rewardId" class="col-12 col-sm-6 col-md-4 col-lg-4">
                            <label for="colFormLabel" class="col-form-label">Updated Balance </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                :value="rewardBalance + formData.points"
                                tabindex="1"
                                placeholder="Updated Balance"
                                type="number"
                                readonly
                            >
                        </div>
                    </div>

                    <div class="col-lg-8 p-1">
                        <div class="mb-1">
                            <label for="description">Note</label>
                            <vField
                                v-model="formData.description"
                                as="textarea"
                                name="description"
                                type="number"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <SubmitCancelBtn
                            class="text-center"
                            @onSubmit="submit"
                            @onCancel="onClickClose"
                            :loading="loading"
                        />
                    </div>

                </div>
            </div>
        </div>
        <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { inject, onMounted, reactive, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleContact from "@/services/modules/contact";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleJournal from '@/services/modules/journal';
import handleInventory from "@/services/modules/inventory";
import { useAsyncDropdownHelper } from "@/services/utils/asyncDropdownHelper";
import useDate from "@/services/utils/day";

const { fetchContactProfiles, fetchSingleContactProfile } = handleContact();
const { fetchAccountHeadsList } = handleJournal();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { storeRewardPoint, updateRewardPoint } = handleInventory();

const props = defineProps({
    onSubmit: {
        type: Function,
        default: () => {}
    },
    modalStateKey: {
        type: String,
        default: null
    },
    rewardData: {
        type: Object,
        default: {}
    },
    rewardId: {
        type: Number,
        default: null
    },
    rewardPointAcc: {
        type: Array
    }
});

const emit = defineEmits(['onSubmit']);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const defaultDate = useDate();
const selectedData = ref({});
const rewardBalance = ref(0);
const formData = reactive({
    company_id: $route.params.companyId,
    contact_profile_id: null,
    account_head_id: null,
    liability_head_id: null,
    points: null,
    date: defaultDate.currentDate(),
    description: null,
    txn_type: 'points_earned'
})

// Computed
const customerMobile = computed(() => {
    if (selectedData.value.profile_items && selectedData.value.profile_items.length) {
        const item = selectedData.value.profile_items.find(
          i => i.field === 'mobile_no' || i.field === 'phone'
        )
        return item ? item.value : null
    }
    return null
})

// Watch 
watch(
  () => formData.contact_profile_id,
  (newValue, oldValue) => {
    if(! newValue) {
        return;
    }

    const companyQuery = `?company_id=${$route.params.companyId}&type=customer&reward_balance=1`;
    fetchSingleContactProfile(newValue, companyQuery).then(res => {
        if (res.data) {
            selectedData.value = res.data;
            rewardBalance.value = res.data.reward_balance || 0;
        }
    })
  }
);

watch(
  () => props.rewardData,
  (newData) => {
    if (!newData || Object.keys(newData).length === 0) return;

    formData.contact_profile_id = newData.contact_profile_id || null;
    formData.account_head_id = newData.account_head_id || null;
    formData.liability_head_id = newData.liability_head_id || null;
    formData.points = newData.points || null;
    formData.date = newData.date || defaultDate.currentDate();
    formData.description = newData.description || null;
    rewardBalance.value = newData.reward_balance || 0;
  },
  { immediate: true, deep: true }
);

// Methods
const onClickClose = () => {
    if(props.modalStateKey){
        $store.state[props.modalStateKey] = false;
        return;
    }
    $store.state.isModalOpenTwo = false;
    resetData();
}

const submit = async() => {
    loading.value = true;
    try {
        const res =  props.rewardId ? await  updateRewardPoint(props.rewardId, formData) :
                    await storeRewardPoint(formData);

        if(! res.status) {
            showError(res.message);
            return;
        }
        
        showSuccess(res.message);
        emit('onSubmit');
        onClickClose();
    } catch (error) {
        console.error("Error storing reward point:", error);
    } finally {
        loading.value = false;
        resetData();
    }
}

const resetData = () => {
    formData.contact_profile_id = null;
    formData.account_head_id = null;
    formData.liability_head_id = null;
    formData.points = null;
    formData.date = defaultDate.currentDate();
    formData.description = null;
    rewardBalance.value = 0;
}
</script>

<style scoped>
.modal-style {
    display: block; 
    background: #1c1d1c33
}

.w-70 {
    width: 70% !important;
}
</style>
